import InvoiceGroupSubcode from 'src/models/AP/InvoiceGroupSubcode';

export default class TsdiInvoiceGroup {
  groupId?: number;
  groupNumber?: number;          // GroupNumber
  invoiceNumber?: number;        // ProjectNumber
  invoiceDate?: Date;         // Date as ISO string
  creationDate?: Date;         // Date as ISO string
  createdBy?: number;            // CreatedBy
  createdByName?: string;            // CreatedBy
  clientNumber?: number;         // ClientNumber
  projectNumber?: number;        // ProjectNumber
  projectId?: number;        // ProjectId
  sectionNumber?: number;        // SectionNumber
  posted?: boolean;              // Posted
  voucher?: boolean;             // Voucher
  description?: string;       // Description
  district?: string;              // District
  tract?: string;                 // Tract
  prospectInvoiceGroup: number;
  groupAccountCode?: string;      // GroupAccountCode
  accountCode?: string;          // AccountCode
  total?: number;                // Total
  groupTotal?: number;           // GroupTotal
  office?: string;               // Office
  requestDate?: Date;          // RequestDate
  closeDate?: Date;            // CloseDate
  closedBy?: number;             // ClosedBy
  closedByName?: string;             // ClosedBy
  frequency?: string;            // Frequency
  frequencyBeginDate?: Date;
  recurrenceCompleted?: number;
  count: number;                 // Count
  sections: number;              // Sections
  addSections?: Array<InvoiceGroupSubcode>;
}


// WEBPACK FOOTER //
// ./src/components/project-billing/models/InvoiceGroup.ts